module.exports = __webpack_public_path__ + "static/WeHeartIt-06f170be186e83a786c9a044b7493ccb.png";